import { c as _c } from "react/compiler-runtime";
import { thousandize } from "../../../../util/formatting";
import styles from "./FundraiserProgressBar.module.scss";
import { FetchFundraiserResult } from "../../../../studio/sanity.types";
export const FundraiserProgressBar: React.FC<{
  config: NonNullable<FetchFundraiserResult["page"]>["fundraiser_goal_config"];
  currentAmount: number;
  locale: string;
}> = t0 => {
  const $ = _c(23);
  const {
    config,
    currentAmount,
    locale
  } = t0;
  if (!config) {
    return "Missing config for fundraiser progress bar";
  }
  const {
    goal,
    current_amount_text_template,
    goal_amount_text_template
  } = config;
  if (!current_amount_text_template) {
    return "Missing current amount text template";
  }
  let t1;
  if ($[0] !== currentAmount || $[1] !== current_amount_text_template || $[2] !== goal || $[3] !== locale) {
    t1 = current_amount_text_template.replace("{amount}", thousandize(currentAmount, locale)).replace("{goal}", thousandize(goal || 0, locale));
    $[0] = currentAmount;
    $[1] = current_amount_text_template;
    $[2] = goal;
    $[3] = locale;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const currentAmountText = t1;
  let t2;
  if ($[5] !== goal || $[6] !== goal_amount_text_template || $[7] !== locale) {
    t2 = goal_amount_text_template ? goal_amount_text_template.replace("{goal}", thousandize(goal || 0, locale)) : "";
    $[5] = goal;
    $[6] = goal_amount_text_template;
    $[7] = locale;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const goalAmountText = t2;
  let t3;
  if ($[9] !== currentAmount || $[10] !== goal) {
    t3 = goal && <div className={styles.barcontainer}><div className={styles.bar} style={{
        width: `${currentAmount / goal * 100}%`
      }} /></div>;
    $[9] = currentAmount;
    $[10] = goal;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== currentAmountText) {
    t4 = <span data-cy="fundraiser-progress-current">{currentAmountText}</span>;
    $[12] = currentAmountText;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== goalAmountText || $[15] !== goal_amount_text_template) {
    t5 = goal_amount_text_template && <span data-cy="fundraiser-progress-goal">{goalAmountText}</span>;
    $[14] = goalAmountText;
    $[15] = goal_amount_text_template;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className={styles.text}>{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t6) {
    t7 = <div className={styles.container} data-cy="fundraiser-progress-bar">{t3}{t6}</div>;
    $[20] = t3;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};